import * as React from 'react';
import clsx from 'classnames';

function SvgClosedEye({className, ...props}) {
    return (
        <svg width={16} height={16} fill="none" className={clsx('text-font-tertiary', className)} {...props}>
            <g opacity={0.7}>
                <path
                    d="M14.745 4.934S11.725 9.226 8 9.226c-3.726 0-6.746-4.292-6.746-4.292"
                    stroke="currentColor"
                    strokeLinecap="round"
                />
                <path
                    d="M10.274 11.103a.5.5 0 10.966-.26l-.966.26zm-.621-2.319l.62 2.319.967-.26-.621-2.317-.966.258zM4.761 10.844a.5.5 0 00.966.259l-.966-.26zm.621-2.318l-.62 2.318.965.259.621-2.319-.966-.258z"
                    fill="currentColor"
                />
                <path d="M2.735 7.133L1.038 8.83M13.266 7.133l1.697 1.697" stroke="currentColor" strokeLinecap="round" />
            </g>
        </svg>
    );
}

export default SvgClosedEye;
